const Calendar = (props) => {
  return (
    <svg width="16" height="17" viewBox="0 0 16 17" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
        <path d="M3 0.333252V1.99992H2.16667C1.25 1.99992 0.5 2.74992 0.5 3.66658V15.3332C0.5 16.2499 1.25 16.9999 2.16667 16.9999H13.8333C14.75 16.9999 15.5 16.2499 15.5 15.3332V3.66658C15.5 2.74992 14.75 1.99992 13.8333 1.99992H13V0.333252H11.3333V1.99992H4.66667V0.333252H3ZM2.16667 3.66658H3H4.66667H11.3333H13H13.8333V5.33325H2.16667V3.66658ZM2.16667 6.99992H13.8333V15.3332H2.16667V6.99992Z" fill="#D71921" />
    </svg>
  );
};

export default Calendar;
